import { atom } from 'recoil'
import { RootType } from './types'
import { GLOBAL_ATOM_KEYS } from './keys'
import { ModalDataType } from './types'
import { MODULE_NAME } from 'core/constants'

export const STORE_ROOT_PROPS = atom<RootType>({
  key: GLOBAL_ATOM_KEYS.STORE_ROOT_PROPS,
  default: undefined,
})

export const STORE_MODULE = atom<MODULE_NAME>({
  key: GLOBAL_ATOM_KEYS.STORE_MODULE,
  default: undefined,
})

export const IS_OPEN_LINK = atom<boolean>({
  key: GLOBAL_ATOM_KEYS.IS_OPEN_LINK,
  default: false,
})

export const IS_OPEN_MODAL = atom<ModalDataType | null>({
  key: GLOBAL_ATOM_KEYS.IS_OPEN_MODAL,
  default: null,
})

export const SNACKBAR_MESSAGE = atom<string | null>({
  key: GLOBAL_ATOM_KEYS.SNACKBAR_MESSAGE,
  default: null,
})
